import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormInputComponent, SharedModule } from '@vendure/admin-ui/core';

@Component({
    selector: 'toggle-boolean-form-input',
    template: `
        <vdr-form-field>
            <clr-toggle-wrapper>
                <input
                    type="checkbox"
                    clrToggle
                    [formControl]="formControl"
                />
            </clr-toggle-wrapper>
        </vdr-form-field>
    `,
    standalone: true,
    imports: [SharedModule],
})
export class ToggleBooleanFormInputComponent implements FormInputComponent<any> {
    readonly: boolean;
    formControl: FormControl;
    config: any;
}


